import React, { CSSProperties } from "react";
import styled from "styled-components";

type FormStepProps = {
    background?: string;
    fontColor?: string;
    noWrap?: boolean;
    children: any;
    style?: CSSProperties;
};

type ContainerStepProp = {
    fontColor?: string;
    $noWrap?: boolean;
};

const Container = styled.div<ContainerStepProp>`
    flex: 1 0 100vw;
    background: linear-gradient(180deg, #F7F6F6 0%, #F7F6F6 62.67%, rgba(247, 246, 246, 0) 100%);
    color: ${(props) => props.fontColor};

    ${({ $noWrap }) => (
        $noWrap === true ? (
            "padding-bottom: 10px;"
        ) : (
            `
                .wrap {
                    max-width: 800px;
                    margin: 0 auto;
                }
            `
        )
    )}

    @media (min-width: 1000px) {
        .step-body {
            min-height: 70px;
        }
    }
`;

const FormStep: React.FC<FormStepProps> = ({ background, fontColor, noWrap, children, style = {} }) => {
    return (
        <Container fontColor={fontColor} $noWrap={noWrap} style={style}>
            <div className="wrap">{children}</div>
        </Container>
    );
};

export default FormStep;
